import { z } from 'zod';

export const fidcStatusMessageValidator = z
  .object({
    cli_cod: z.number().int().positive()
  })
  .passthrough();

export type FidcStatusMessage = z.infer<typeof fidcStatusMessageValidator>;
